import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached phones data
export function usePhonesSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/phones"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
